
import { Outlet, RouteObject } from 'react-router'
import Home from '../pages/Home'
import Bookmarks from '../pages/Bookmarks'
import ArticleView from '../pages/ArticleView'
import Layout from './Layout'
import { homeLoader } from '../pages/loaders/homeLoader'
import { articleViewLoader } from '../pages/loaders/articleViewLoader'
import { LayoutLoader } from '../pages/loaders/layoutLoader'

import DasboardLayout from '../pages/dashboard/Layout'
import Dashboard from '../pages/dashboard/Dashboard'
import DashboardCreateArticle from '../pages/dashboard/CreateArticle'
import { dashboardLoader } from '../pages/loaders/dashboardLoader'
import Edit from '../pages/Edit'
import { editLoader } from '../pages/loaders/editLoader'
import History from '../pages/History'
import { historyLoader } from '../pages/loaders/historyLoader'
import { dashboardCreateArticleLoader } from '../pages/loaders/dashboardCreateArticleLoader'
import DashboardCreateTag from '../pages/dashboard/CreateTag'
import TagView from '../pages/TagView'
import { tagViewLoader } from '../pages/loaders/tagViewLoader'
import ErrorPage from '../pages/ErrorPage'
import Searching from '../pages/Searching'
import { searchingLoader } from '../pages/loaders/searchingLoader'
import HistoryDiff from '../pages/HistoryDiff'
import { historyDiffLoader } from '../pages/loaders/historyDiffLoader'
import LoadingPage from '../components/LoadingPage'

export const routes: RouteObject[] = [
    {
        element: <Layout />,
        hydrateFallbackElement: <></>,
        errorElement: <ErrorPage />,
        loader: LayoutLoader,
        children: [
            {
                path: "/",
                element: <Home />,
                loader: homeLoader,
                HydrateFallback: LoadingPage
            },
            {
                path: "/bookmarks",
                element: <Bookmarks />
            },
            {
                path: "/edit/:id",
                element: <Edit />,
                loader: editLoader
            },
            {
                path: "/history/preview/:revision",
                element: <HistoryDiff />,
                loader: historyDiffLoader
            },
            {
                path: "/history/:id",
                element: <History />,
                loader: historyLoader
            },
            {
                path: "/tag/:name",
                element: <TagView />,
                loader: tagViewLoader
            },
            {
                path: "/search",
                element: <Searching />,
                loader: searchingLoader
            },
            {
                path: "/dashboard",
                element: <DasboardLayout />,
                children: [
                    {
                        index: true,
                        element: <Dashboard />,
                        loader: dashboardLoader,
                    },
                    {
                        path: 'create',
                        children: [
                            {
                                index: true,
                                element: <code>/create root</code>
                            },
                            {
                                path: 'article',
                                element: <DashboardCreateArticle />,
                                loader: dashboardCreateArticleLoader
                            },
                            {
                                path: 'category',
                                element: <DashboardCreateTag />
                            }
                        ]
                    }
                ]
            },
            {
                path: "/*",
                element: <ArticleView />,
                loader: articleViewLoader
            },
        ]
    }
]